import { mapSpaceValue } from '../../Layouts/LayoutUtils'
import { Spacing } from '../../Layouts/LayoutTypes'

type FixedSpaceValues = '8px' | '16px' | '24px' | '32px'

export type MarginProps = {
    marginTop?: number | number[] | string | string[]
    marginBottom?: number | number[] | string | string[]
    marginLeft?: number | number[] | string | string[]
    marginRight?: number | number[] | string | string[]
    marginX?: number | number[] | string | string[]
    marginY?: number | number[] | string | string[]
}

export type PositionProps = {
    position?: 'relative' | 'absolute'
    top?: number
    bottom?: number
    left?: number
    right?: number
    zIndex?: number
}

export type SpacingProps = {
    spaceX?: Spacing | Spacing[]
    spaceY?: Spacing | Spacing[]
    spaceLeft?: Spacing | Spacing[]
    spaceRight?: Spacing | Spacing[]
    spaceTop?: Spacing | Spacing[]
    spaceBottom?: Spacing | Spacing[]
}

export type PaddingProps = {
    paddingX?: string | number | undefined | (string | number | undefined)[]
    paddingY?: string | number | undefined | (string | number | undefined)[]
    paddingLeft?: string | number | undefined | (string | number | undefined)[]
    paddingRight?: string | number | undefined | (string | number | undefined)[]
    paddingTop?: string | number | undefined | (string | number | undefined)[]
    paddingBottom?: string | number | undefined | (string | number | undefined)[]
}

export type FixedMarginProps = {
    marginX?: FixedSpaceValues | FixedSpaceValues[]
    marginY?: FixedSpaceValues | FixedSpaceValues[]
    marginLeft?: FixedSpaceValues | FixedSpaceValues[]
    marginRight?: FixedSpaceValues | FixedSpaceValues[]
    marginTop?: FixedSpaceValues | FixedSpaceValues[]
    marginBottom?: FixedSpaceValues | FixedSpaceValues[]
}

export type FixedPaddingProps = {
    paddingX?: FixedSpaceValues | FixedSpaceValues[]
    paddingY?: FixedSpaceValues | FixedSpaceValues[]
    paddingLeft?: FixedSpaceValues | FixedSpaceValues[]
    paddingRight?: FixedSpaceValues | FixedSpaceValues[]
    paddingTop?: FixedSpaceValues | FixedSpaceValues[]
    paddingBottom?: FixedSpaceValues | FixedSpaceValues[]
}

export type BorderProps = {
    border?: number | string | number[] | string[]
    borderX?: number | string | number[] | string[]
    borderY?: number | string | number[] | string[]
    borderBottom?: number | string | number[] | string[]
    borderLeft?: number | string | number[] | string[]
    borderRight?: number | string | number[] | string[]
    borderTop?: number | string | number[] | string[]
    borderColor?: string | string[]
    borderRadius?: number | string | number[] | string[]
    borderTopLeftRadius?: number | string | number[] | string[]
    borderTopRightRadius?: number | string | number[] | string[]
    borderBottomLeftRadius?: number | string | number[] | string[]
    borderBottomRightRadius?: number | string | number[] | string[]
}

export const getPaddingPropsBySpacing = ({
    spaceX,
    spaceY,
    spaceLeft,
    spaceRight,
    spaceBottom,
    spaceTop,
}: SpacingProps): PaddingProps => {
    const paddingStyles: PaddingProps = {}
    if (spaceY) {
        paddingStyles['paddingY'] = mapSpaceValue(spaceY)
    }
    if (spaceX) {
        paddingStyles['paddingX'] = mapSpaceValue(spaceX)
    }
    if (spaceLeft) {
        paddingStyles['paddingLeft'] = mapSpaceValue(spaceLeft)
    }
    if (spaceRight) {
        paddingStyles['paddingRight'] = mapSpaceValue(spaceRight)
    }
    if (spaceTop) {
        paddingStyles['paddingTop'] = mapSpaceValue(spaceTop)
    }
    if (spaceBottom) {
        paddingStyles['paddingBottom'] = mapSpaceValue(spaceBottom)
    }

    return paddingStyles
}

type DisplayValues = 'none' | 'flex'
export type DisplayProp = {
    display?: DisplayValues | DisplayValues[]
}
